import {
  BeamPocketSettings,
  InteriorConditionSettings,
  StepSettings,
  TraySettings,
  VerticalStackSettings,
} from '@paragon/contract-library';

export type InteriorConditionType = InteriorConditionSettings['type'];
export const InteriorConditionTypes: InteriorConditionType[] = [
  'step' as const,
  'verticalStack' as const,
  'beamPocket' as const,
  'tray' as const,
];

export const InteriorConditionNames: { [type in InteriorConditionType]: string } = {
  step: 'Step',
  verticalStack: 'Interior Bearing',
  beamPocket: 'Beam Pocket',
  tray: 'Tray',
};

export function getInteriorConditionTypeName(type: InteriorConditionType): string {
  return InteriorConditionNames[type];
}

export function createInteriorConditionNameGenerator() {
  const occurrences: { [type in InteriorConditionType]: number } = {
    step: 0,
    verticalStack: 0,
    beamPocket: 0,
    tray: 0,
  };

  return function getInteriorConditionName(condition: InteriorConditionSettings, direction?: string) {
    occurrences[condition.type] += 1;
    if (direction) {
      return `${InteriorConditionNames[condition.type]} ${occurrences[condition.type]} (${direction})`;
    }
    return `${InteriorConditionNames[condition.type]} ${occurrences[condition.type]}`;
  };
}

export const InteriorConditionCreationMethods = {
  step: createStepSettings,
  verticalStack: createVerticalStackSettings,
  beamPocket: createBeamPocketSettings,
  tray: createTraySettings,
};

export function createInteriorConditionSettings(type: InteriorConditionType) {
  return InteriorConditionCreationMethods[type]();
}

export function createStepSettings(): StepSettings {
  return {
    type: 'step',
    guid: crypto.randomUUID(),

    distanceFromLeft: 0,
    stepDistance: 6,
    stepDirection: 'Up',
  };
}

export function createTraySettings(): TraySettings {
  return {
    type: 'tray',
    guid: crypto.randomUUID(),

    distanceFromLeft: 0,
    stepUp: 6,
    trayWidth: 96,
    stepDown: 6,
  };
}

export function createVerticalStackSettings(): VerticalStackSettings {
  return {
    type: 'verticalStack',
    guid: crypto.randomUUID(),

    distanceFromLeft: 0,
    bearingWidth: 4.5,

    hasBearing: true,
    verticalsCount: 2,
  };
}

export function createBeamPocketSettings(): BeamPocketSettings {
  return {
    type: 'beamPocket',
    guid: crypto.randomUUID(),

    distanceFromLeft: 0,
    bearingWidth: 4.5,

    pocketWidth: 4.5,
    pocketHeight: 8,

    bottomChordCutOut: true,
    leftVerticalsCount: 1,
    rightVerticalsCount: 0,
  };
}
